// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill';
import App from './App'
import router from './router'

import 'styles/rest.css'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer);
//引入调用vuex
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// 1引入调用vuex
import Vuex from 'vuex'
import store from '../store/store'
import './assets/Toast/toast.css'
import Toast from './assets/Toast/index'
Vue.use(VueAwesomeSwiper, /* { default global options } */);
Vue.use(Vuex)
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
Vue.config.productionTip = false
Vue.use(Toast)
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  Vuex,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js